import React, { Fragment } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import SimpleTwoColumnTableRow from './SimpleTwoColumnTableRow';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';


// currentStudyProgramInfo
export default class CurrentStudyTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentYear: '',
            showEditForm: false,
            showEditTitleGenderForm: false,
        };
        this.saveComment = this.saveComment.bind(this);
        this.saveTitleGender = this.saveTitleGender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        axios.get('/genders')
            .then(res => {
                let genders = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    genders
                });
            });
    }

    componentWillMount() {
        axios.get('/academic-years/current')
            .then(res => {
                this.setState({ currentYear: res.data.id });
            });
    }

    saveComment() {
        let obj = {
            sspComment: this.state.comment,
        };
        axios.put(`students/edit-ssp-comment/${this.props.studentId}/${this.props.studyProgramId}`, { ...obj })
            .then(res => {
                this.props.getCurrentStudyProgramInfo();
                this.setState({ showEditForm: false });
                toast('Izmjena napomene je uspješno izvršena.');
            })
            .catch(err => {
                console.log('Failed to edit comment.');
                toast('Došlo je do greške! Izmjena napomene nije izvršena.');
            });
    }


    saveTitleGender() {
        axios.put(`students/edit-gender-for-title/${this.props.studentId}/${this.props.studyProgramId}/${this.state.titleGender}`)
            .then(res => {
                this.props.getCurrentStudyProgramInfo();

                toast('Izmjena za rod za titulu je uspješno izvršena.');
            })
            .finally(() => {
                this.setState({ showEditTitleGenderForm: false });
            })
            .catch(err => {
                console.log('Failed to edit comment.');
                toast('Došlo je do greške! Izmjena za rod za titulu nije izvršena.');
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });
    }

    render() {
        const { currentStudyProgramInfo, faculties, departments } = this.props;
        return (
            this.props.currentStudyProgramInfoLoader ?
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                :
                <Table celled size="small" unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {!this.props.noIndex && <SimpleTwoColumnTableRow
                            name="Index"
                            keyName="index"
                            value={currentStudyProgramInfo.index}
                        />}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.faculty" />}
                            keyName="faculties"
                            value={faculties.map(el => (<div>{el.name} <br /></div>))}
                        />
                        { departments.length ? <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.department" />}
                            keyName="department"
                            value={departments.map(el => (<div>{el.name}</div>))}
                        /> : null}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyProgram" />}
                            keyName="studyProgramBasic"
                            value={
                                <Fragment>
                                    <Grid columns={3}>
                                        <Grid.Column width={8} verticalAlign="middle" >{currentStudyProgramInfo.studyProgramBasic || currentStudyProgramInfo.studyProgram ? currentStudyProgramInfo.studyProgramBasic +
                                                (
                                                    (localStorage.getItem('activeRole').substr(0, 8) !== 'Student:'
                                                        && localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' && localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan') ?
                                                        ' | ' + currentStudyProgramInfo.studyProgram
                                                        : ''
                                                ) : ''}</Grid.Column>
                                        <Grid.Column width={8} verticalAlign="middle" textAlign="right" >
                                            {(localStorage.getItem('activeRole').substr(0, 8) !== 'Student:'
                                                    && localStorage.getItem('activeRole').substr(0, 20) !== 'Diplomirani student:' && localStorage.getItem('activeRole').substr(0, 7) !== 'Ispisan') ? <Link
                                                    target="blank_"
                                                    onClick={() => {
                                                        localStorage.setItem('studyProgramBasic', currentStudyProgramInfo.studyProgramBasicId);
                                                        localStorage.setItem('id', currentStudyProgramInfo.studyProgramBasicId);
                                                        localStorage.setItem('basicName', currentStudyProgramInfo.studyProgramBasic);
                                                        localStorage.setItem('archived', currentStudyProgramInfo.archived);
                                                        localStorage.setItem('studyProgramBasicName', currentStudyProgramInfo.studyProgramBasic);
                                                        localStorage.setItem('implementation', JSON.stringify({ studyProgram: { name: currentStudyProgramInfo.studyProgram, id: JSON.parse(localStorage.getItem('student')).studyProgramId ? JSON.parse(localStorage.getItem('student')).studyProgramId : currentStudyProgramInfo.studyProgram.id }, studyProgramBasicName: currentStudyProgramInfo.studyProgramBasic }));
                                                    }}
                                                    to={{ pathname: (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') ? '/osnovni-studijski-programi/implementacije/semestri' : '/studijski-programi/implementacije/semestri' }}
                                                >
                                                    <Popup
                                                        size="tiny"
                                                        trigger={<Button
                                                            basic="true"
                                                            circular
                                                            color="blue"
                                                            icon="external alternate"
                                                            size="mini"
                                                        />}
                                                        content="Idi na studijski program"
                                                        hideOnScroll
                                                        position="top center"
                                                        />
                                                </Link> : null}
                                        </Grid.Column>
                                    </Grid>


                                </Fragment>

                            }
                        />
                        {/* {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' && <SimpleTwoColumnTableRow */}
                        {/*    name={<FormattedMessage id="common.semester" />} */}
                        {/*    keyName="currentSemester" */}
                        {/*    value={currentStudyProgramInfo.gradStudentAcademicYear ? currentStudyProgramInfo.gradStudentAcademicYear.id === this.state.currentYear ? 'Apsolventski staž' : currentStudyProgramInfo.currentSemester : currentStudyProgramInfo.currentSemester} */}
                        {/* />} */}
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyCycle" />}
                            keyName="studyCycle"
                            value={currentStudyProgramInfo.studyCycles ? currentStudyProgramInfo.studyCycles[0].name : ''}
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.studyType" />}
                            keyName="studyType"
                            value={currentStudyProgramInfo.studyType}
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.semester" />}
                            keyName="currentSemester"
                            value={currentStudyProgramInfo.gradStudentAcademicYear ? currentStudyProgramInfo.gradStudentAcademicYear.id === this.state.currentYear ? 'Apsolventski staž' : currentStudyProgramInfo.currentSemester : currentStudyProgramInfo.currentSemester}
                        />
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="studentDocuments.status" />}
                            keyName="status"
                            value={currentStudyProgramInfo.studentStatus}
                        />
                        {(this.props.currentEducation && currentStudyProgramInfo.droppedOutDate !== null) &&
                        <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.dateOfAbandonment" />}
                            keyName="dateOfAbandonment"
                            value={moment(currentStudyProgramInfo.droppedOutDate).format('D. M. YYYY.')}
                        />
                        }

                        {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') && <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.titleGender" />}
                            keyName="titleGender"
                            value={
                                <Fragment>

                                    {!this.state.showEditTitleGenderForm ?
                                        <Grid columns={2}>
                                            <Grid.Column width={14} verticalAlign="middle" > {currentStudyProgramInfo.genderForTitle ? currentStudyProgramInfo.genderForTitle.name : ''} </Grid.Column>
                                            {(!this.props.limitation || !this.props.locked) && <Grid.Column width={2} verticalAlign="middle" >
                                                <Popup
                                                    size="tiny"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        floated="right"
                                                        color="green"
                                                        icon="pencil"
                                                        size="mini"
                                                        onClick={() => {
                                                            this.setState({ showEditTitleGenderForm: true });
                                                        }}
                                                    />}
                                                    content="Izmijeni"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>}
                                        </Grid>

                                        :
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <Form.Field>
                                                    <Form.Dropdown
                                                        placeholder="Odaberite rod"
                                                        options={this.state.genders}
                                                        onChange={this.handleInputChange}
                                                        name="titleGender"
                                                        value={this.state.titleGender ? this.state.titleGender : this.props.currentStudyProgramInfo.genderForTitle ? this.props.currentStudyProgramInfo.genderForTitle.id : null}
                                                        search
                                                        fluid
                                                        selection
                                                    />
                                                </Form.Field>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveTitleGender();
                                                        this.setState({ showEditTitleGenderForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditTitleGenderForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    }
                                </Fragment>}
                        />}
                        {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') && <SimpleTwoColumnTableRow
                            name={<FormattedMessage id="common.comment" />}
                            keyName="comment"
                            value={
                                <Fragment>

                                    {!this.state.showEditForm ?
                                        <Grid columns={2}>
                                            <Grid.Column width={14} verticalAlign="middle" > {currentStudyProgramInfo.sspComment} </Grid.Column>
                                            {(((localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') && (!this.props.limitation || !this.props.locked)) || (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator')) && <Grid.Column width={2} verticalAlign="middle" >
                                                <Popup
                                                    size="tiny"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        floated="right"
                                                        color="green"
                                                        icon="pencil"
                                                        size="mini"
                                                        onClick={() => {
                                                            this.setState({ showEditForm: true });
                                                        }}
                                                    />}
                                                    content="Dodaj napomenu"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Grid.Column>}
                                        </Grid>

                                        :
                                        <Form size="mini">
                                            <Form.Group widths="equal">
                                                <Form.Field width="2">
                                                    <input
                                                        defaultValue={currentStudyProgramInfo.sspComment}
                                                        value={this.state.comment}
                                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                                        name="comment"
                                                        placeholder="Unesite napomenu"

                                                    />
                                                </Form.Field>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.saveComment();
                                                        this.setState({ showEditForm: false });
                                                    }}
                                                >
                                                    Sačuvaj
                                                </Button>
                                                <Button
                                                    basic="true"
                                                    size="mini"
                                                    floated="right"
                                                    onClick={() => {
                                                        this.setState({ showEditForm: false });
                                                    }}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    }
                                </Fragment>}
                        />}
                    </Table.Body>
                </Table>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/CurrentStudyTable.js